module.exports = "<p-menubar [model]=\"items\"></p-menubar>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home-page/top-menu/top-menu.component.html
// module id = ./src/app/components/home-page/top-menu/top-menu.component.html
// module chunks = main